import { max } from 'moment';
import styled, { keyframes, css } from 'styled-components';

interface ChartProps {
  $APillarName: 'apillar1' | 'apillar2';
  $imageBackGround?: string;
  size?: string | number; // default width (string | number, px)
}

/**
 * ConcentricCircles
 * React component that renders 3 concentric circles (SVG).
 * Props:
 *  - size: default width (string | number, px)
 *  - colors: Array of 3 CSS color strings [outer, middle, inner]
 *  - stroke: stroke color for circle outlines (default: none)
 *  - strokeWidth: number (default: 0)
 *  - className: for styled-components overrides
 *  - title: accessible title for the SVG
 */

export const Wrap = styled.div`
  width: 30cm; /* Largura da página A4 */
  min-height: 29.7cm; /* Altura mínima da página A4 (pode crescer) */

  margin: 10px;
  padding: 20px;
  font-family: 'Dosis', sans-serif;

  h1 {
    font-weight: 800;
    font-size: 80px;
    font-family: 'Dosis', sans-serif;
  }
  h2 {
    font-weight: 800;
    font-size: 38px;
    font-family: 'Dosis', sans-serif;
  }
  // h3 {
  //   margin-left: 20px;
  //   font-weight: 400;
  //   font-family: 'Dosis', sans-serif;
  // }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  //justify-content: space-evenly;
  //align-items: center;
  min-height: 640px;
  margin-left: 40px;
  margin-top: 1px;

  @media (max-width: 1126px) {
    flex-direction: column;
  }
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const appearFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const ChartContainer = styled.div<ChartProps>`
  width: 45rem;

  margin-right: 10px;

  //padding: 30px 15px 40px 43px;
  padding: 41px 27px 45px 57px;
  // /* display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center; */

  background: url(${props => props.$imageBackGround}) no-repeat 1rem 1rem;
  background-size: 100%;
  animation: ${appearFromLeft} 1s;

  img {
    display: block;
    box-sizing: border-box;

    height: 542px;
    width: 542px;
    padding: 10px !important;
  }

  @media (max-width: 70.375rem) {
    width: 100%;
    padding: 0;
    background-size: 49%;
    background-position: center 2.5rem;
    padding-bottom: 3.125rem;
  }
`;

export const LeftContainer = styled.div`
  position: relative;
`;

export const TextContainer = styled.div`
  background-color: #f2efeb;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 50px;
  margin-left: 30px;
  margin-top: 100px;
  color: #682d45;
  font-family: 'Dosis', sans-serif;
`;

export const Header = styled.div`
  padding: 20px;
  font-family: 'Dosis', sans-serif;

  p {
    color: #f2efeb;
    text-align: justify;
    margin-top: 10px;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.2 !important;
    font-family: 'Dosis', sans-serif;
  }
  span {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.2 !important;
    font-family: 'Dosis', sans-serif;
  }
`;

export const HeaderLine = styled.div`
  display: flex;
  margin-bottom: 35px;
  margin-top: 35px;
  font-family: 'Dosis', sans-serif;

  h1 {
    font-weight: 900;
    font-size: 44px;
    flex: 1;
    margin-right: 20px;
    color: #682d45;
    font-family: 'Dosis', sans-serif;
  }
  span {
    color: #682d45;
    font-size: 44px;
    font-family: 'Dosis', sans-serif;
  }
`;

export const SubTitle = styled.div`
  display: flex;
  margin-bottom: 20px;
  margin-top: 20px;
  font-family: 'Dosis', sans-serif;

  h1 {
    font-weight: 900;
    font-size: 36px;
    flex: 1;
    margin-right: 20px;
    color: #682d45;
    font-family: 'Dosis', sans-serif;
  }
  span {
    color: #682d45;
    font-size: 36px;
    font-family: 'Dosis', sans-serif;
  }
`;

export const Score = styled.span`
  font-size: 28px;
  color: #28000a;
  font-weight: bold;
  font-family: 'Dosis', sans-serif;
`;

export const Body = styled.div`
  width: 100%;
  padding: 20px 30px;
  margin: 10px;
  font-size: 20px;
  font-family: 'Dosis', sans-serif;
`;

export const BodyLine = styled.div<ChartProps>`
  display: flex;
  font-family: 'Dosis', sans-serif;

  h3 {
    margin-bottom: 30px;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.2 !important;
    font-family: 'Dosis', sans-serif;
  }

  h4 {
    flex: 1;
    margin-right: 20px;
    margin-bottom: 30px;
    font-family: 'Dosis', sans-serif;
  }

  ${props =>
    props.$APillarName === 'apillar2' &&
    css`
      &:last-child {
      }
    `}
`;

export const RefreshButton = styled.button`
  border: 0 none;
  background-color: transparent;
  display: inline-flex;
  margin: 0 190px 0 0;
  float: right;

  &:hover {
    opacity: 0.7;
  }
`;

export const ButtonLeft = styled.button`
  border: 0 none;
  background-color: transparent;
  position: absolute;
  top: 170px;
  left: -55px;

  &:hover {
    opacity: 0.7;
  }
`;

export const ButtonRight = styled.button`
  border: 0 none;
  background-color: transparent;
  position: absolute;
  top: 170px;
  right: -55px;

  &:hover {
    opacity: 0.7;
  }
`;

export const BottomContainer = styled.div`
  font-family: 'Dosis', sans-serif;

  p {
    margin: 10px 0 0;
    font-size: 13px;
    font-family: 'Dosis', sans-serif;
  }
  padding: 10px;
`;

export const BoxFooter = styled.div`
  background-color: #fff;
  padding: 14px;
  margin: 20px 0 0;

  ul {
    margin: 5px 30px;

    li {
      a {
        color: #017698;
        text-decoration: underline;
        margin-left: 5px;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
`;

export const SvgWrapper = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36rem;
  height: 36rem;
  z-index: 1;

  /* Responsividade */
  @media (max-width: 480px) {
    width: 120px;
    height: 120px;
  }

  @media (min-width: 481px) and (max-width: 1024px) {
    width: 200px;
    height: 200px;
  }

  @media (min-width: 1025px) {
    width: 36rem;
    height: 36rem;
    max-width: 100%;
  }
`;

export const ChartWrapper = styled.div`
  position: relative;
  z-index: 2;
`;
